import React, { FC } from 'react';
import classNames from 'classnames';
import { ASSETS_PATH } from '@root/app/react/const/variables';

const assets = `${ASSETS_PATH}/img`;

export interface PartsCompleteButtonProps {
    title: string;
    title2?: string | null;
    status: 'none' | 'valid';
    required: boolean;
    onClick: React.MouseEventHandler<HTMLDivElement>;
    even?: boolean;
}

export const PartsCompleteButton: FC<PartsCompleteButtonProps> = (props) => {
    const {
        title,
        title2 = null,
        status,
        required,
        onClick,
        even = false,
    } = props;

    const bgc = required ? 'require' : 'elective';
    const bgColorClass = status === 'valid' ? 'success' : bgc;
    const rimg = required ? 'require-error.svg' : 'optional.svg';
    const requireImg2 = status === 'valid' ? 'success.svg' : rimg;
    const requireUrl = `${assets}/common/${requireImg2}`;

    const classNameEven = classNames({
        evenClass: even === true,
    });

    return (
        <button
            type="button"
            className={`parts-complete-button ${bgColorClass} ${classNameEven}`}
            onClick={onClick}
        >
            <img className="require" src={requireUrl} role="presentation" alt="" />
            <figure className="title">
                <figcaption>{title}</figcaption>
                {title2 !== null && <figcaption>{title2}</figcaption>}
            </figure>
        </button>
    );
};
